import React, { useEffect, useRef, useState } from 'react';

const Pokemon = ({pokemon, dataIsLoaded}) => {

    const [infosOpened, setInfosOpened] = useState(false);
    const pokemonRef = useRef(null);

    const padNumber = (num) => {
        return num.toString().padStart(4, '0');
    }

    const handleClickInside = () => {
        setInfosOpened((prev) => !prev);
    }

    const handleClickOutside = (event) => {
        if (pokemonRef.current && !pokemonRef.current.contains(event.target)) {
            setInfosOpened(false);
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <li className={infosOpened ? 'pokemon view-infos' : 'pokemon'} onClick={handleClickInside} ref={pokemonRef} >
            <img src={pokemon.sprite} alt={"Illustration du Pokémon " + pokemon.french_name} onLoad={() => dataIsLoaded()} />
            <div className='infos'>
                <h3>{pokemon.french_name}</h3>
                <p className='english-name'>{pokemon.english_name}</p>
                <p className='pokedex-infos'>
                    #{padNumber(pokemon.pokedex)}
                    <span></span> 
                    <strong>
                        GEN {pokemon.generation}
                    </strong>
                </p>
            </div>
        </li>
    );
};

export default Pokemon;